import React, { useState } from 'react'
import "./CSS/EmailLogin.css"

const EmailLogin = ({loginForm, setLoginForm, handleSubmit: handleSubmitFromParent, userSignUp}) => {

    //  const [loginForm, setLoginForm] = useState({email: "", password: ""})

    const handleSubmit = (e) => {
        e.preventDefault();
        handleSubmitFromParent()
        // setLoginForm({email: "", password: ""})
    }

    const handleChange = (e) => {
        let newFormState = {...loginForm};
        newFormState[e.target.name] = e.target.value;
        setLoginForm(newFormState);
    }

    const setLoginCredentials = () => {
        setLoginForm({email: 'abc@gmail.com', password: "abcrocks!!"})
    }

    const handleSignUp = (e) => {
        e.preventDefault();
        userSignUp()
    }

    return (
        <form className='email-form'>
            <div className='label-input-container'>
                <label className='input-label' htmlFor="email">Email Address</label>
                <input className='input-box' type="text" id="email" name="email" placeholder='Email address'
                value={loginForm.email}  onChange={(e) => handleChange(e)}/>
            </div>
            <div className='label-input-container'>
                <label className='input-label' htmlFor="password">Password</label>
                <input className='input-box' autoComplete='on' type="password" id="password" name="password" placeholder="Password"
                value={loginForm.password} onChange={(e) => handleChange(e)}/>
            </div>
            <div className='main-signup-container'>
                <p className='login-credentials'
                onClick={setLoginCredentials}>Use Test Credentials</p>
                <div className='email-signin-signup-button-container'>
                     <button className='email-submit-button' onClick={(e) => handleSubmit(e)}>Login</button>
                    <button className='email-submit-button' onClick={(e) => handleSignUp(e)}>Sign Up</button>
                </div>
            </div>
        </form>
    )
}

export default EmailLogin